import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/processes/pipelines')({
  staticData: {
    title: 'Pipelines',
    crumb: 'Pipelines',
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
